import { Component, Input, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Address, DocContact } from 'src/app/acumatica/EntityServices/Contacts.service';
import { Country, CountryService, State } from 'src/app/acumatica/EntityServices/Country.service';
import { Customer } from 'src/app/acumatica/EntityServices/Customer.service';
import { NotFoundError } from 'src/app/acumatica/acumatica-errors';

@Component({
  selector: 'so-shipto-input',
  templateUrl: './so-shipto-input.component.html',
  styleUrls: ['./so-shipto-input.component.css']
})
export class SoShiptoInputComponent implements OnInit {

  @Input() disabled?: boolean;
  @Input() order!: ISOShipTo;
  @Input()
  get customer(): Customer | null | undefined { return this._customer; }
  set customer(value: Customer | null | undefined) { this._customer = value; if (value?.Country) this.setCountry(value.Country) }
  private _customer?: Customer | null;

  countries: Country[] = [];
  get countryID() { return this.order.ShipToAddress!.Country; }
  set countryID(value) {
    if (value != this.order.ShipToAddress!.Country) {
      this.order.ShipToAddress!.City = null;
      this.order.ShipToAddress!.State = null;
      this.order.ShipToAddress!.PostalCode = null;
      this.order.ShipToAddress!.Country = value;
      this.setCountry(value);
    }
  }
  states: State[] = [];

  get stateID() { return this.order.ShipToAddress!.State; }
  set stateID(value) {
    if (value != this.order.ShipToAddress!.State) {
      if (!value) return;
      this.order.ShipToAddress!.State = value.toString().toUpperCase();
    }
  }

  get componentDisabled(): boolean { return !!this.disabled || !this.customer; }

  constructor(
    private countryService: CountryService
  ) { }

  ngOnInit(): void {
    if (this.order === undefined) throw new Error('`order` is required on `so-shipto-input` component');

    let countries = localStorage.getItem('countries-list');
    if (countries == null) {
      this.countryService.getCountries({ loader: null }).subscribe(countries => {
        localStorage.setItem('countries-list', JSON.stringify(countries));
        this.countries = countries;
      });
    }
    else this.countries = JSON.parse(countries).map((country: any) => new Country(country));
  }

  setCountry(countryID: string | null) {
    if (!countryID) { this.states = []; return; }
    countryID = countryID.toUpperCase().trim();
    let country = this.countries.find(country => country.ID == countryID);
    if (!country) { this.states = []; return; }
    countryID = country.ID;
    if (this.order.ShipToAddress) this.order.ShipToAddress!.Country = countryID;

    let storageKey = 'country-states-' + countryID;
    let states = localStorage.getItem(storageKey)
    if (states == null) {
      this.countryService.getStates(countryID, { loader: null, expand: 'States' }).subscribe(country => {
        localStorage.setItem(storageKey, JSON.stringify(country.States));
        this.states = country.States!;
      }, error => {
        if (error instanceof NotFoundError) {
          // silently disregard -- user may be manually typing country code
          this.states = [];
        }
        else throw error;
      })
    }
    else this.states = JSON.parse(states).map((state: any) => Object.assign(new State(), state));
  }

  // overrideContactChange(event: MatSlideToggleChange) {
  //   if (event.checked) {
  //     this.order.ShipToContact = new DocContact({
  //       BusinessName: this.customer?.PrimaryContact?.CompanyName,
  //       Attention: this.customer?.PrimaryContact?.DisplayName,
  //       Phone1: this.customer?.PrimaryContact?.Phone1,
  //       Email: this.customer?.PrimaryContact?.Email
  //     });
  //   }
  // }

  // overrideAddressChange(event: MatSlideToggleChange) {
  //   if (event.checked) {
  //     this.order.ShipToAddress = new Address({
  //       AddressLine1: this.customer?.AddressLine1,
  //       AddressLine2: this.customer?.AddressLine2,
  //       City: this.customer?.City,
  //       State: this.customer?.State,
  //       PostalCode: this.customer?.PostalCode,
  //       Country: this.customer?.Country,
  //     });

  //     this.setCountry(this.order.ShipToAddress!.Country);
  //   }
  // }
}

interface ISOShipTo {
  ShipToContactOverride?: boolean;
  ShipToAddressOverride?: boolean;
  ShipToContact?: DocContact | null;
  ShipToAddress?: Address | null;
}